export const Cookie = {
  set(name, value, days = 7) {
    const expires = days 
      ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()}` 
      : '';
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
  },
  get(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 
      ? decodeURIComponent(parts.pop().split(';').shift()) 
      : null;
  },
  remove(name) {
    this.set(name, '', -1);
  }
};
